import * as Yup from 'yup';

export class AuthValidations {
  public static loginValidation() {
    return Yup.object().shape({
      emailAddress: Yup.string()
        .email('Please enter a valid email address')
        .required('Please enter your email address'),
      password: Yup.string().required('Please enter your password')
    });
  }

  public static twoFactorLoginValidation() {
    return Yup.object().shape({
      otp: Yup.string()
        .matches(/^[0-9]+$/, 'Your verification code must only contain digits')
        .min(6, 'Please enter the 6-digit verification code')
        .required('Please enter your verification code')
    });
  }
}
